<template>
    <a-modal
      :title="$t('reject-modal.title')"
      :visible="visible"
      :closable="false"
      :okText="$t('modal-btn.confirm-btn-caption')"
      :cancelText="$t('modal-btn.cancel-btn-caption')"
      :confirm-loading="isLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >

        <appointment-summary :appointment="item" />
        
        <a-form-item class="mb-5 mt-20">	
            <a-form-item :label="$t('form-label.rejection-reason')" >
                <a-input
                    style="margin-left: 5px;"
                    class="form-input"
                    :placeholder="$t('form-placeholder.rejection-reason')"
                    v-model="reason"
                />
            </a-form-item>
        </a-form-item>
    </a-modal>
</template>
<script>

import { useAppointmentsStore } from '../../../../stores/appointments-store';
import { mapState } from 'pinia';
import { toastMixin } from '../../../../mixins/ToastMixin';
import { appointmentsClient } from '../../../../api/config';
import AppointmentSummary from '../../items/AppointmentSummary.vue';
export default {
    components: {
        AppointmentSummary
    },
    mixins: [ toastMixin ],
    data() {
        return {
            title: 'Are You Sure You Want to Reject this appointment ?',
            isLoading: false,
            visible: false,
            reason: ''
        }
    },
    computed: {
        ...mapState(useAppointmentsStore, { 'item': 'selectedAppointment' })
    },
    methods: {
        handleOk() {
            this.isLoading = true;
            let data = { id: this.item.id, reason: this.reason };
            appointmentsClient.rejectAppoinment(data).then(res => {
                if (!res.networkError) {
                    if (res.status == 202) {
                        this.visible = false;
                        this.successToast(this.$t('toast-success-messages.appointment-reject'));    
                        this.$emit('success', this.item.id);
                    } else {
                        this.errorToast(this.$t('toast-error-messages.error') + res.status);    
                    }
                } else {
                    this.errorToast(this.$t('toast-error-messages.network-error'));    
                }
                
                this.isLoading = false;
            });
        },
        handleCancel() {
            this.visible = false;
        },
        showModal() {
            this.visible = true;
        },
    }
    
}
</script>